// extracted by mini-css-extract-plugin
export default {"impressumOverlay":"Impressum_impressumOverlay__nv1jf","impressumContent":"Impressum_impressumContent__5eMH-","closeButton":"Impressum_closeButton__6IW6F"};